import i18n from "i18next";
import ar from "./locales/ar.json";
import fr from "./locales/fr.json";

// Langues livrées : chaque fichier doit être complet (scripts/check-i18n.mjs bloque la livraison sinon).
// Aucune langue de repli : une clé absente s'affiche telle quelle, jamais dans une autre langue (CA-01).
export const languages = ["ar", "fr"] as const;
export type Language = (typeof languages)[number];
export const resources = { ar: { translation: ar }, fr: { translation: fr } };

void i18n.init({
  resources,
  lng: "ar",
  supportedLngs: languages,
  fallbackLng: false,
  returnNull: false,
  returnEmptyString: false,
  interpolation: { escapeValue: false },
});
export default i18n;
